import React from "react";

interface CharacterCounterProps {
  value?: string | number | null;
  maxLength: number;
  className?: string;
}

export const CharacterCounter: React.FC<CharacterCounterProps> = ({
  value = "",
  maxLength,
  className = "text-end small text-muted mt-1",
}) => {
  const currentLength = value !== undefined && value !== null ? String(value).length : 0;
  return (
    <div className={className}>
      {currentLength} / {maxLength} characters
    </div>
  );
};

export default CharacterCounter;
